export enum MutationTypes {
  //AuthModule mutations
  AUTH_REQUEST = "AUTH_REQUEST",
  AUTH_SUCCESS = "AUTH_SUCCESS",
  AUTH_ERROR = "AUTH_ERROR",
  AUTH_LOGOUT = "AUTH_LOGOUT",
  CSRF_TOKEN_SET = "CSRF_TOKEN_SET",
  HAS_TOKEN = "HAS_TOKEN",
  TOKEN_STATUS = "TOKEN_STATUS",
  VALIDATE_SUCCESS = "VALIDATE_SUCCESS",
  VALIDATE_ERROR = "VALIDATE_ERROR",
  TOKEN_LOADED = "TOKEN_LOADED",
  //Features
  SET_FIXED_PLATFORMS = "SET_FIXED_PLATFORMS",
  SET_MOBILE_PLATFORMS = "SET_MOBILE_PLATFORMS",
  SET_LINEAL_PLATFORMS = "SET_LINEAL_PLATFORMS",
  SET_PIPELINES = "SET_PIPELINES",
  SET_CHANNELS = "SET_CHANNELS",
  SET_CHART_ACHARE = "SET_CHART_ACHARE",
  SET_CUSTOM_ACHARE = "SET_CUSTOM_ACHARE",
  SET_SELECTED_FIXED_PLATFORM = "SET_SELECTED_FIXED_PLATFORM",
  SET_SELECTED_MOBILE_PLATFORM = "SET_SELECTED_MOBILE_PLATFORM",
  ERASE_SELECTED_FEATURES = "ERASE_SELECTED_FEATURES",
  CHANGE_PLATFORM_TAG = "CHANGE_PLATFORM_TAG",
  //Maps
  SET_MAPCENTER = "SET_MAPCENTER",
  UPDATE_ZOOM = "UPDATE_ZOOM",
  SET_TARGETS_TAG_ZOOM = "SET_TARGETS_TAG_ZOOM",
  SET_PLATFORMS_TAG_ZOOM = "SET_PLATFORMS_TAG_ZOOM",
  UPDATE_BBOX = "UPDATE_BBOX",
  SELECT_BASELAYER = "SELECT_BASELAYER",
  SELECT_FEATURES = "SELECT_FEATURES",
  SELECT_TARGETS = "SELECT_TARGETS",
  ACTIVATE_MEASUREMENT = "ACTIVATE_MEASUREMENT",
  CHANGE_MEASUREMENTS_UNITS = "CHANGE_MEASUREMENTS_UNITS",
  ADD_MEASUREMENT_POINT = "ADD_MEASUREMENT_POINT",
  CLEAR_MEASUREMENT = "CLEAR_MEASUREMENT",
  UPDATE_TOTAL_DISTANCE = "UPDATE_TOTAL_DISTANCE",
  //Targets
  SET_TARGETS = "SET_TARGETS",
  SET_SELECTED_VESSEL = "SET_SELECTED_VESSEL",
  ERASE_SELECTED_VESSEL = "ERASE_SELECTED_VESSEL",
  SET_SELECTED_SAR = "SET_SELECTED_SAR",
  ERASE_SELECTED_SAR = "ERASE_SELECTED_SAR",
  ERASE_SELECTED_TARGETS = "ERASE_SELECTED_TARGETS",
  SET_PREDICTION_TIME = "SET_PREDICTION_TIME",
  SET_ATONS = "SET_ATONS",
  SET_BS = "SET_BS",
  CHANGE_TARGETS_TAG = "CHANGE_TARGETS_TAG",
  //UserModule mutations
  USER_SUCCESS = "USER_SUCCESS",
  USER_ERROR = "USER_ERROR",
  USER_LOGOUT = "USER_LOGOUT",
  //UserAdmin
  USER_LIST = "USER_LIST",
  TOKEN_LIST = "TOKEN_LIST",
}
